import SoundManager from 'logic/sound/SoundManager'
import InitManager from 'managers/InitManager'

export default class Managers {
  constructor() {
    this.SoundManager = new SoundManager()
    this.InitManager = new InitManager()
  }
}
